import type { TFunction } from "i18next";
import type { ConnectorSummary } from "@/api";

export function connectorName(
  connector: Pick<ConnectorSummary, "name" | "transport"> & { isOrg?: boolean },
  t: TFunction<"connectors">,
): string {
  if (!connector.isOrg) return connector.name;
  const key = connector.transport === "builtin" ? "orgLabel.organization" : "orgLabel.personal";
  return t(key, { name: connector.name });
}
